// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"b6ea8add","632":"a62d8198","864":"5451631a","916":"e9b99761","933":"fc1d5dcb"}[chunkId] + ".chunk.js";
};